<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Add Game Images" @show="setUpdateData" @hide="closeModal()">
    <b-card>
      <b-row>
        <b-col sm="12">
          <p-input disabled v-model="form.gameName" label="Game Name" name="gameName" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <template v-for="(x) in imageField">
          <b-col sm="4" :key="x" v-if="form.gameTag === x">
            <strong>{{ getLabel(x) }}</strong>
            <div v-if="form.gameImage && form.gameImage[x]" class="game-image-wrap">
              <img :src="form.gameImage[x].ImgUrl" />
              <b-btn variant="danger" style="width: 120px;" @click="removeImage(form.gameImage[x].ImgId, x)">Remove</b-btn>
            </div>
            <p-image v-else v-model="form[x]" :name="x" :handler="$v" :formData="form" class="platform-image"/>
          </b-col>
        </template>
      </b-row>
      <b-row class="mt-4">
        <b-col sm="12">
          <b-btn variant="success" @click="submit()">Save</b-btn>
          <b-btn variant="danger" @click="closeModal()">Cancel</b-btn>
        </b-col>
      </b-row>
    </b-card>
    <b-modal ref="confirm" size="sm" centered header-bg-variant="primary" hide-footer title="Remove This Image">
      <div class="mb-3">
        Are you sure?
      </div>
      <b-button variant="success" @click="confirmRemove">Yes</b-button>
      <b-button variant="outline-danger" @click="cancelRemove">Cancel</b-button>
    </b-modal>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput, PImage } from '../../../components'
const _ = require('underscore')

export default {
  name: 'UpdateModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: () => {}
    },
    imageField: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      gameKind: [],
      removeData: {},
      form: {
        gameName: '',
        gameImage: '',
        gameTag: ''
      }
    }
  },
  validations: {
    form: {
      gameName: {required},
      gameImage: {},
      gameTag: {}
    }
  },
  components: {
    PInput,
    PImage
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  methods: {
    getLabel (label) {
      let l = label.charAt(0).toUpperCase() + label.slice(1) + 'Image'
      return l.replace(/([A-Z])/g, ' $1').trim()
    },
    setUpdateData () {
      this.form.gameName = this.updateData.GameName
      this.form.gameImage = this.updateData.GameImages
      this.form.gameTag = this.updateData.GameTag
      this.imageField.forEach(x => {
        this.form[x] = ''
        this.$v.form[x] = {}
      })
    },
    async formatBase64 (img) {
      const base64DataArray = await Promise.all(img.map(async x => {
        return new Promise(resolve => {
          const reader = new FileReader()
          reader.onload = function (event) {
            const base64val = event.target.result
            resolve({ category: x.category, value: base64val })
          }
          reader.readAsDataURL(x.value)
        })
      }))
      return base64DataArray
    },
    formatImage () {
      let img = this.imageField.map(x => {
        const formImg = this.form[x]
        if (formImg) {
          return {
            category: x,
            value: formImg
          }
        }
      })

      return _.compact(img)
    },
    removeImage (id, type) {
      this.removeData = { id, type }
      this.$refs.confirm.show()
    },
    cancelRemove () {
      this.removeData = {}
      this.$refs.confirm.hide()
    },
    async confirmRemove () {
      try {
        Events.$emit('loader')
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }

        await this.$http.delete(this.API_ENDPOINT + '/game/image/' + this.removeData.id, { headers: { 'Content-Type': 'application/json' } })
        delete this.form.gameImage[this.removeData.type]
        this.$forceUpdate()
        this.cancelRemove()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async submit () {
      try {
        Events.$emit('loader')
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }

        let formData = {
          image: await this.formatBase64(this.formatImage())
        }
        await this.$http.put(this.API_ENDPOINT + '/game/image/' + this.updateData.GameId, formData, { headers: { 'Content-Type': 'application/json' } })
        this.closeModal()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    closeModal () {
      this.$v.form.$reset()
      this.$emit('closeModal')
    }
  }
}
</script>


<style >
.image-preview {
  filter: drop-shadow(2px 4px 6px black);
}
.game-image-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 1rem
}

.game-image-wrap img {
  max-width: 200px;
  max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/game/images/Update.vue